module.exports = __webpack_public_path__ + "static/media/em-123.1500c93f.png";